const WonderKind = {
  STATUE: 0x01,
  TEMPLE: 0x02,
  PALACE: 0x04,
  ARENA: 0x08,
  FORTRESS: 0x10,
  NATURE: 0x20,
  NAVAL: 0x40
};

export default WonderKind;
